import { VariationTypeEnum } from '@utilities/enums';
import { Product, Color, Size, ColorSizeEntry } from '@utilities/types';

/**
 * Retourne la quantité disponible d'un produit en fonction de ses variations
 */
export const getAvailableStock = (
  product: Product,
  selectedColor?: string,
  selectedSize?: string
): number => {
  const variations = product.variations;

  switch (product.variationType) {
    case VariationTypeEnum.NONE:
      return (variations as { quantity: number }).quantity;

    case VariationTypeEnum.COLOR:
      return (variations as { colors: Color[] }).colors.find(c => c.color === selectedColor)?.quantity || 0;

    case VariationTypeEnum.SIZE:
      return (variations as { sizes: Size[] }).sizes.find(s => s.size === selectedSize)?.quantity || 0;

    case VariationTypeEnum.BOTH:
      return (
        (variations as { colorSizeData: ColorSizeEntry[] })
          .colorSizeData
          .find(c => c.color === selectedColor)
          ?.sizes.find(s => s.size === selectedSize)?.quantity || 0
      );

    default:
      return 0;
  }
};
